import {
  FormClassRetire,
  RetireFlowReason,
  RetireReason,
} from "../../assets/data/Constants";
import TkTitle from "../../components/atoms/TkTitle";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const tableList: ITkFakeTableLineProps[] = [
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "退職者情報を確認してください。",
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "退職者生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "退職者加入年月日",
    keyword: "firstJoinDate",
    type: "text",
  },
  {
    title: "退職年月日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "退職理由",
    keyword: "nRetireReasonCd",
    type: "text",
  },
  {
    title: "退職手続きの理由",
    keyword: "retireProcedureReason",
    type: "text",
  },
  {
    title: "退職者郵便番号",
    keyword: "zipcode",
    type: "text",
  },
  {
    title: "退職者住所",
    keyword: "address",
    type: "text",
  },
  {
    title: "退職者電話番号",
    keyword: "tel",
    type: "text",
  },
  {
    title:
      "現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である",
    keyword: "continueTransferApplicable1Flg",
    showLine: false,
    type: "text",
  },
  {
    title:
      "現在の共済契約者の退職日の翌日が、転職先の共済契約者への就職日である",
    keyword: "continueTransferApplicable2Flg",
    showLine: false,
    type: "text",
  },
  {
    title: "転職先の共済契約者番号",
    keyword: "aContractorNo",
    showLine: false,
    type: "text",
  },
  {
    title: "転職先の共済契約者名",
    keyword: "aCorpName",
    showLine: false,
    type: "text",
  },
  {
    title: "退職月の出勤日数",
    keyword: "retireWorkingDayNum",
    showLine: false,
    type: "text",
  },
  {
    keyword: "title3",
    type: "lineTitle",
    lineTitle: <TkTitle>{"育休状況"}</TkTitle>,
  },
  {
    title: "ならない月",
    keyword: "noMonth",
    type: "checkboxGroup",
    checkBoxList: [
      {
        label: "無",
        value: "",
        disabled: true,
      },
      {
        label: "4月",
        value: "4",
        disabled: true,
      },
      {
        label: "5月",
        value: "5",
        disabled: true,
      },
      {
        label: "6月",
        value: "6",
        disabled: true,
      },
      {
        label: "7月",
        value: "7",
        disabled: true,
      },
      {
        label: "8月",
        value: "8",
        disabled: true,
      },
      {
        label: "9月",
        value: "9",
        disabled: true,
      },
      {
        label: "10月",
        value: "10",
        disabled: true,
      },
      {
        label: "11月",
        value: "11",
        disabled: true,
      },
      {
        label: "12月",
        value: "12",
        disabled: true,
      },
      {
        label: "1月",
        value: "1",
        disabled: true,
      },
      {
        label: "2月",
        value: "2",
        disabled: true,
      },
      {
        label: "3月",
        value: "3",
        disabled: true,
      },
    ],
  },
  {
    keyword: "title4",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    keyword: "childcareLeaveList",
    type: "node",
  },
  {
    keyword: "childcareActiveListList",
    type: "node",
  },
  {
    keyword: "sixMonthsSalaryList",
    type: "node",
  },
  {
    keyword: "title6",
    type: "lineTitle",
    lineTitle: <TkTitle>{"添付書類"}</TkTitle>,
    showLine: true,
  },
  {
    title: "退職理由",
    keyword: "retireReason",
    type: "text",
    showLine: true,
  },
  {
    title: "現認証明書（傷病）",
    keyword: FormClassRetire["現認証明書（事務取扱要領　様式10-2号）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireFlowReason["傷病による退職"],
  },
  {
    title:
      "労働者災害補償保険の「障害補償給付又は傷病補償年金の支給決定通知書」（写）",
    keyword:
      FormClassRetire["障害補償給付又は傷病補償年金の支給決定通知書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireFlowReason["傷病による退職"],
  },
  {
    title: "障害厚生年金の受給を証する書類等（写）",
    keyword: FormClassRetire["障害厚生年金の受給を証する書類又は医師の診断書"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireFlowReason["傷病による退職"],
  },
  {
    title: "現認証明書（死亡）",
    keyword: FormClassRetire["現認証明書（事務取扱要領　様式10-3号）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireFlowReason["死亡による退職"],
  },
  {
    title: "「死亡診断書又は死体検案書」（写）",
    keyword: FormClassRetire["死亡診断書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireFlowReason["死亡による退職"],
  },
  {
    title:
      "「葬祭料(葬祭給付)の支給決定通知書」(写)又は「第三者行為災害届」(写)(労基署受理のもの)",
    keyword:
      FormClassRetire["葬祭料の支給決定通知書（写）又は第三者行為災害届（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireFlowReason["死亡による退職"],
  },
  {
    title: "生計維持に関する調査書（戸籍上の配偶者が請求者となる場合は不要）",
    keyword: FormClassRetire["生計維持に関する調査書（様式11号）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireFlowReason["死亡による退職"],
  },
  {
    title: "問題行為の概要がわかる書類",
    keyword: FormClassRetire["問題行動の概要が分かる書類"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "懲戒処分・解雇の辞令（写） ",
    keyword: FormClassRetire["懲戒処分・解雇の辞令（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "解雇等処分について審議された議事録（写）",
    keyword: FormClassRetire["解雇処分について審議された議事録（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "就業規則（写）",
    keyword: FormClassRetire["就業規則（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "処分対象者の答弁が含まれる記録（写）、自認書（写）等",
    keyword: FormClassRetire["事情聴取の調書等の記録書面（写）、自認書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "判決書（写）",
    keyword: FormClassRetire["判決書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "新聞記事（写）",
    keyword: FormClassRetire["新聞記事（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "その他当機構が求めた書類",
    keyword: FormClassRetire["その他機構が求めた書類"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: RetireReason["犯罪等による退職"],
  },
  {
    title: "賃金台帳",
    id: "4",
    keyword: FormClassRetire["賃金台帳"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    keyword: "title7",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    keyword: "title8",
    type: "lineTitle",
    showLine: true,
    lineTitle: <TkTitle>{"退職手当金支払いの順番"}</TkTitle>,
  },
  {
    title: "福祉医療機構以外からの退職金受け取りの有無",
    keyword: "prefectureRetirementJoinFlg",
    showLine: true,
    type: "text",
  },
  {
    title: "退職手当請求の順番",
    keyword: "retirementInvoiceOrder",
    showLine: true,
    type: "text",
  },
  {
    keyword: "title9",
    type: "lineTitle",
    showLine: true,
    lineTitle: <TkTitle>{"源泉徴収票"}</TkTitle>,
  },
  {
    title: "退職所得の源泉徴収票（１枚目）",
    keyword: FormClassRetire["退職所得の源泉徴収票_退職届1枚目"],
    type: "downloadLink",
    showLine: true,
    downloadBase64: true,
    id: "page1",
  },
  {
    title: "区分（１枚目）",
    keyword: "page1Kbn",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "支払金額（１枚目）",
    keyword: "page1PaymentAmt",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "源泉徴収額（１枚目）",
    keyword: "page1WithholdingAmt",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "特別徴収税額：市町村民税（１枚目）",
    keyword: "page1ScAmtCity",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "特別徴収税額：都道府県税（１枚目）",
    keyword: "page1ScAmtPrefecture",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "勤続年数（１枚目）",
    keyword: "page1LengthOfService",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "就労年月日（１枚目）",
    keyword: "page1EmployedDate",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "退職年月日（１枚目）",
    keyword: "page1RetiredDate",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "控除期間（年）（１枚目）",
    keyword: "page1DeductionPeriodYear",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "控除期間（月）（１枚目）",
    keyword: "page1DeductionPeriodMonth",
    type: "text",
    showLine: false,
    id: "page1",
  },
  {
    title: "退職所得の源泉徴収票（２枚目）",
    keyword: FormClassRetire["退職所得の源泉徴収票_退職届2枚目"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: "page2",
  },
  {
    title: "区分（２枚目）",
    keyword: "page2Kbn",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "支払金額（２枚目）",
    keyword: "page2PaymentAmt",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "源泉徴収額（２枚目）",
    keyword: "page2WithholdingAmt",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "特別徴収税額：市町村民税（２枚目）",
    keyword: "page2ScAmtCity",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "特別徴収税額：都道府県税（２枚目）",
    keyword: "page2ScAmtPrefecture",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "勤続年数（２枚目）",
    keyword: "page2LengthOfService",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "就労年月日（２枚目）",
    keyword: "page2EmployedDate",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "退職年月日（２枚目）",
    keyword: "page2RetiredDate",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "控除期間（年）（２枚目）",
    keyword: "page2DeductionPeriodYear",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "控除期間（月）（２枚目）",
    keyword: "page2DeductionPeriodMonth",
    type: "text",
    showLine: false,
    id: "page2",
  },
  {
    title: "退職所得の源泉徴収票（３枚目）",
    keyword: FormClassRetire["退職所得の源泉徴収票_退職届3枚目"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    id: "page3",
  },
  {
    title: "区分（３枚目）",
    keyword: "page3Kbn",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "支払金額（３枚目）",
    keyword: "page3PaymentAmt",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "源泉徴収額（３枚目）",
    keyword: "page3WithholdingAmt",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "特別徴収税額：市町村民税（３枚目）",
    keyword: "page3ScAmtCity",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "特別徴収税額：都道府県税（３枚目）",
    keyword: "page3ScAmtPrefecture",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "勤続年数（３枚目）",
    keyword: "page3LengthOfService",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "就労年月日（３枚目）",
    keyword: "page3EmployedDate",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "退職年月日（３枚目）",
    keyword: "page3RetiredDate",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "控除期間（年）（３枚目）",
    keyword: "page3DeductionPeriodYear",
    type: "text",
    showLine: false,
    id: "page3",
  },
  {
    title: "控除期間（月）（３枚目）",
    keyword: "page3DeductionPeriodMonth",
    type: "text",
    showLine: false,
    id: "page3",
  },
];

const headTitleList1 = [
  { headTitle: "順番" },
  {
    headTitle: "出生日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパ・ママ育休プラス",
  },
  {
    headTitle: "半年延長の理由",
  },
  {
    headTitle: "産後パパ育休",
  },
];

const headTitleList2 = [
  { headTitle: "年月" },
  {
    headTitle: "俸給表の額",
  },
  {
    headTitle: "俸給の調整額手当",
  },
  {
    headTitle: "俸給の調整額",
  },
];

const headListWorkingDayNum = [
  {
    headTitle: "対象年月",
  },
  {
    headTitle: "出勤日数",
  },
];

export { tableList, headTitleList1, headTitleList2, headListWorkingDayNum };
